var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home "},[_c('section',[_c('Logo')],1),_c('footer',[_vm._v(" Hlutur AS - IoT - Program utvikling - Opplæring - Fagreiser - Workshops ")])])}
var staticRenderFns = []

export { render, staticRenderFns }